import { createFileRoute } from '@tanstack/react-router'
import { claimTypesEnum } from 'User/utils/claims'
import WorkAssets from 'Work/components/Work/Sections/Assets/WorkAssets'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/work/$workId/assets')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_asset]}>
            <WorkAssets />
        </Guard>
    ),
})
